import { mapGetters } from 'vuex';

import PzButton from '@/components/PzButton.vue';
import TrackerButton from '@/components/TrackerButton.vue';
import EmptyList from '@/views/Events/components/EmptyList.vue';
//import EventListInPanel from '@/views/Events/components/EventListInPanel.vue';

export default {
  name: 'MainModeMyPaperList',

  components: {
    PzButton,
    TrackerButton,
    EmptyList,
    //EventListInPanel,
  },

  props: {
    goThroughMock: {
      type: Function,
      default: () => null,
    },

    redoMock: {
      type: Function,
      default: () => null,
    },
  },

  data() {
    return {};
  },

  computed: {
    ...mapGetters({
      userInfo: 'userInfo',
    }),

    ...mapGetters('Events', {
      mg_MyDoneList: 'MyDoneList',
      mg_selectedMyDoneList: 'selectedMyDoneList',
    }),
  },
};
